import React, { useState } from "react";
import { CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

/**
 * Email subscribe form wired to the Ghost Members backend proxy.
 * Separate from EarlyAccessForm (Brevo waitlist) — this subscribes
 * to the blog newsletter via Ghost's Members API.
 */
export default function GhostSubscribeForm({ className = "" }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await api.post("/ghost/subscribe", { email: email.trim() });
      setDone(true);
    } catch (err) {
      toast.error(
        err?.response?.data?.detail || "Subscription failed — please try again."
      );
    } finally {
      setLoading(false);
    }
  }

  if (done) {
    return (
      <div className={`flex items-center gap-2 text-sm text-emerald-700 ${className}`}>
        <CheckCircle2 className="h-4 w-4 shrink-0" />
        <span>You&apos;re subscribed. New posts delivered to your inbox.</span>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className={`flex gap-2 ${className}`}>
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="your@email.com"
        required
        className="flex-1 min-w-0 rounded-md border border-border bg-card px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-brand"
      />
      <button
        type="submit"
        disabled={loading}
        className="shrink-0 bg-brand text-brand-foreground px-4 py-2 rounded-md text-sm font-medium hover:opacity-90 transition-opacity disabled:opacity-60"
      >
        {loading ? "…" : "Subscribe"}
      </button>
    </form>
  );
}
